import { render, staticRenderFns } from "./VideoTable.vue?vue&type=template&id=77b0bca2&scoped=true&"
import script from "./videotable.js?vue&type=script&lang=js&"
export * from "./videotable.js?vue&type=script&lang=js&"
import style0 from "./VideoTable.vue?vue&type=style&index=0&id=77b0bca2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b0bca2",
  null
  
)

export default component.exports